import { render, staticRenderFns } from "./charges.html?vue&type=template&id=74674c7b&scoped=true&external"
import script from "./charges.js?vue&type=script&lang=js&external"
export * from "./charges.js?vue&type=script&lang=js&external"
import style0 from "./charges.scss?vue&type=style&index=0&id=74674c7b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74674c7b",
  null
  
)

export default component.exports